import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import ReactDOM from "react-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuthStore } from "../../../store/useAuthStore";
import "../modal.css";

const EnterOtp = ({ onClose,enablePopup,resetOtpPopup,userId }) => {
  const {verifyOtp} = useAuthStore()

  const handleVerifyOtp = async (otp) => {
      const response =  await verifyOtp({
        user_id: userId,
        otp: otp
      })
  
      if(response.status) {
        toast.success(response?.message, {toastId: 'successMessageVerifyOtp'});
        onClose();
        enablePopup();
      } else {
        toast.error(response?.message ?? 'something went wrong', {toastId: 'errorMessageVerifyOtp'})
      }
    }

  const formik = useFormik({
    initialValues: {
      otp: "",
    },
    validationSchema: Yup.object({
        otp: Yup.string()
        .matches(/^\d{4}$/, "OTP must be exactly 4 digits")
        .required("OTP is required"),
    }),
    onSubmit: (values) => {
      handleVerifyOtp(values.otp)
    },
  });

  return ReactDOM.createPortal(
    <>
      <div className="custom-modal-backdrop" onClick={onClose}></div>
      <div className="custom-modal">
        <div className="custom-modal-content">
          <div className="custom-modal-header">
            <h5 className="custom-modal-title">Verify OTP</h5>
            <button className="custom-close-btn" onClick={onClose}>&times;</button>
          </div>
          <div className="custom-modal-body">
            <form onSubmit={formik.handleSubmit}>
              <div className="form-group">
                <label>Enter OTP</label>
                <div className="input-group">
                  <input
                    type='text'
                    className={`custom-input ${formik.touched.otp && formik.errors.otp ? "error" : ""}`}
                    name="otp"
                    value={formik.values.otp}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
                {formik.touched.otp && formik.errors.otp && <div className="error-text">{formik.errors.otp}</div>}
              </div>

              <div className="custom-modal-footer">
                <button type="submit" className="inline-flex w-full justify-center rounded-md bg-emerald-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-emerald-500 sm:ml-3 sm:w-auto">Verify</button>
                <button type="button" className="custom-btn resend-otp" onClick={resetOtpPopup}>Resend OTP</button>
                <button type="button" className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50 sm:mt-0 sm:w-auto" onClick={onClose}>Close</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>,
    document.getElementById("popup-root")
  );
};

export default EnterOtp;
